import React from "react";
import config from "config";
import DetailDropDown from "./detailDropDown/DetailDropDown";
import { DetailProps } from "./detailDropDown/detail/Detail";

function Session() {
  const details: Array<DetailProps> = [
    { title: "Dates", detail: `June ${config.sessionInformation.dates}` },
    { title: "Theme", detail: config.sessionInformation.theme },
    { title: "Scripture", detail: config.sessionInformation.scripture },
    { title: "Song", detail: `PBH #${config.sessionInformation.hymnNumber}` },
    { detail: config.sessionInformation.hymnName },
  ];

  return (
    <DetailDropDown
      title={`${config.sessionInformation.year} SESSION`}
      initiallyOpen
      details={details}
    />
  );
}

export default Session;
